<div class="container container-main">
  <app-reports-general-header />
  <app-reporting-subnav></app-reporting-subnav>
  <div class="card border-0 p-3">
    <div class="card-body">
      <h2 class="fw-bolder text-center mb-4">
        Staff Member Credits Earned Report
      </h2>

      <div class="d-flex justify-content-between align-items-center">
        <app-report-filter-bar
          [canFilterByDistrict]="canFilterByDistrict"
          [reportName]="'credits_earned'"></app-report-filter-bar>
        <div>
          <button
            ngbTooltip="Download CSV"
            aria-label="Download CSV"
            class="btn"
            container="body"
            placement="bottom"
            [autoClose]="false"
            [ngbPopover]="csvDownloadingPopover"
            [disabled]="disableDownload"
            (click)="downloadCSV()"
            #p="ngbPopover">
            <i [ngClass]="['bi', 'fs-21', 'bi-download']"></i>
          </button>
          <ng-template #csvDownloadingPopover>
            <div class="p-2">
              Your report is generating. The download will begin shortly.
            </div>
            <div class="p-2 d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="p.close()">
                OK
              </button>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="card border-0 table-container">
        <table class="table">
          <thead>
            <tr class="align-middle">
              <th
                scope="col"
                (sort)="onSort($event)"
                sortable="user_name"
                class="sortable-header"
                style="min-width: 250px">
                User
                <i class="bi bi-caret-down {{ sortIconTemp.user_name }}"></i>
              </th>

              <th
                scope="col"
                (sort)="onSort($event)"
                sortable="session_count"
                class="sortable-header"
                style="min-width: 200px">
                # Training Events Attended
                <i
                  class="bi bi-caret-down {{ sortIconTemp.session_count }}"></i>
              </th>
              <th
                scope="col"
                (sort)="onSort($event)"
                sortable="competency_count"
                class="sortable-header"
                style="min-width: 220px">
                # Competencies In Events
                <i
                  class="bi bi-caret-down {{
                    sortIconTemp.competency_count
                  }}"></i>
              </th>
              <th
                scope="col"
                (sort)="onSort($event)"
                sortable="total_credits_earned"
                class="sortable-header"
                style="min-width: 150px">
                Total Credits Earned
                <i
                  class="bi bi-caret-down {{
                    sortIconTemp.total_credits_earned
                  }}"></i>
              </th>
              <ng-container *ngFor="let creditType of creditTypes">
                <th scope="col" class="sortable-header">
                  {{ creditType }}
                </th>
              </ng-container>
              <th
                scope="col"
                (sort)="onSort($event)"
                sortable="cohorts"
                class="sortable-header"
                style="min-width: 220px">
                Cohort(s)
                <i class="bi bi-caret-down {{ sortIconTemp.cohorts }}"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!isLoading; else loadingTemplate">
              <ng-container *ngIf="tableData.length; else noTableData">
                <tr *ngFor="let item of tableData" class="align-middle">
                  <td>
                    <a href="/training/transcript/{{ item.userId }}">{{
                      item.userName
                    }}</a>
                  </td>

                  <td class="text-center">
                    {{ item.sessionCount }}
                  </td>
                  <td class="text-center">
                    {{ item.competencyCount }}
                  </td>
                  <td class="text-center">
                    {{ item.totalCreditsEarned }}
                  </td>
                  <ng-container *ngFor="let creditType of creditTypes">
                    <td class="text-center">
                      {{ item.creditTypes[creditType] || 0 }}
                    </td>
                  </ng-container>
                  <td class="px-4">
                    <span
                      *ngFor="let cohort of item.cohorts"
                      class="badge badge-item me-1"
                      title="{{ cohort }}">
                      {{ cohort }}
                    </span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
          <ng-template #loadingTemplate>
            <div class="loader-container">
              <app-loader></app-loader>
            </div>
          </ng-template>
        </table>
        <ng-template #noTableData>
          <tr>
            <td></td>
            <td></td>
            <td>
              <p class="text-center my-5">No Event Credits Found.</p>
            </td>
          </tr>
        </ng-template>
      </div>
      <section>
        <div class="d-flex justify-content-center mt-4">
          <ngb-pagination
            *ngIf="listMeta && listMeta.totalCount > 10"
            [(page)]="listMeta.currentPage"
            [pageSize]="listMeta.perPage"
            [collectionSize]="listMeta.totalCount"
            [maxSize]="5"
            (pageChange)="paginationChange()"></ngb-pagination>
        </div>
      </section>
    </div>
    <div class="mt-5 text-muted small text-end">
      Data last refreshed at {{ lastUpdatedDate }}
    </div>
  </div>
</div>
